import Swal from 'sweetalert2';
import authHelper from './helpers/authHelper';
import { axiosErrorHandler, axiosResponseHandler, callTheApServerGet, callTheApServerPost } from './helpers/axiosHelper';
import { hydrateApBasicData } from './helpers/basicHelper';
import { addDNoneClass, byId } from './helpers/utility';





authHelper.validate();
hydrateApBasicData();
// checking query params for transition result alert













const supportDetailsMethodNameInput = byId('supportDetailsMethodNameInput');
const supportDetailsMethodIdInput = byId('supportDetailsMethodIdInput');
const supportDetailsMethodIconInput = byId('supportDetailsMethodIconInput');
const supportDetailsMethodOnClickLinkInput = byId('supportDetailsMethodOnClickLinkInput');
const supportDetailsSubmitBtn = byId('supportDetailsSubmitBtn');







const addSupportMethodFun = () => {
    const data = {
        methodName: supportDetailsMethodNameInput.value,
        methodId: supportDetailsMethodIdInput.value,
        icon: supportDetailsMethodIconInput.value,
        onClickLink: supportDetailsMethodOnClickLinkInput.value,
    };
    callTheApServerPost(`/basic/addSupportMethod`, { data: data }).then((response) => {
        axiosResponseHandler(response);
        const res = response.data;






        if (res.status === 'success') {
            console.log(res);


            Swal.fire({
                title: 'Support Method added',
                icon: 'success',
                showConfirmButton: false,


                allowOutsideClick: false,


            });

            setTimeout(() => {
                location.reload();
            }, 3000);



        }
    }).catch((error) => {
        axiosErrorHandler(error);
        console.log(error);
    });
};

supportDetailsSubmitBtn.addEventListener('click', addSupportMethodFun);

const deleteSupportMethodFun = (sn) =>{
    callTheApServerGet(`/basic/deleteSupportMethod/${sn}`).then((response) => {
        axiosResponseHandler(response);
        const res = response.data;

        if (res.status === 'success') {
            console.log(res);


            Swal.fire({
                title: 'Support Method Deleted',
                icon: 'success',
                showConfirmButton: false,


                allowOutsideClick: false,


            });

            setTimeout(() => {
                location.reload();
            }, 3000);



        }
    }).catch((error)=>{
        axiosErrorHandler(error);
        console.log(error);
    });
};


window.deleteSupportMethodFun=deleteSupportMethodFun;

// get wallet history



const getSupportMethodsFun = () => {


    callTheApServerGet(`/basic/getSupportMethods`).then((response) => {
        axiosResponseHandler(response);
        const res = response.data;




        const supportMethodsTableBodyElement = byId('supportMethodsTableBodyElement');
        const supportMethodsTableNoDataRowElement = byId('supportMethodsTableNoDataRowElement');

        if (res.status === 'success') {
            console.log(res);

            const supportMethodsData = res.supportMethodsData;
            let i = 0;





            if (supportMethodsData.length > 0) {

                addDNoneClass(supportMethodsTableNoDataRowElement, true);


                while (i < supportMethodsData.length) {
                    const { sn, methodName, methodId, icon, onClickLink } = supportMethodsData[i];

                    supportMethodsTableBodyElement.innerHTML +=`
                    <tr>
                    
                        <td>${i + 1}</td>
                    
                        <td>${methodName}</td>
                        <td>${methodId}</td>
                      
                    
                        <td>${icon}</td>
                        <td>${onClickLink}</td>
                        <td><button class="btn btn-danger" onclick="deleteSupportMethodFun(${sn})" >Delete</button></td>
                      
                    </tr>
                    `;
                    i++;
                }
            }

            if (supportMethodsData.length === 0) {
                supportMethodsTableNoDataRowElement.innerHTML = `
                <th class='text-center' colspan='6'>No Wallet Transactions Found 😥</th> 
                `;




            }



        }
    }).catch((error) => {
        axiosErrorHandler(error);
        console.log(error);
    });
};

getSupportMethodsFun();




